import { ky } from './ky';
import { AccountDto } from './account';
import { TermsDto } from './terms';

export default class MemberService {
  /**
   * 비밀번호 변경 (로그인 상태에서 현재 비밀번호로 변경)
   * @param currentPassword 현재 비밀번호
   * @param newPassword     새 비밀번호
   */
  async passwordReset(currentPassword: string, newPassword: string) {
    return await ky.put('v1/members/password', {
      json: {
        currentPassword,
        newPassword
      }
    });
  }

  /**
   * 비밀번호 초기화 메일 전송
   * @param email 이메일 주소
   */
  async requestPasswordReset(email: string) {
    return await ky.post('v1/members/password-reset', {
      json: { email }
    });
  }

  /**
   * 토큰으로 비밀번호 재설정
   * @param token 비밀번호 초기화 토큰
   * @param password 새 비밀번호
   */
  async resetPasswordWithToken(token: string, password: string) {
    return await ky.put('v1/members/password-reset', {
      json: { token, password }
    });
  }
}

